import { AuthRequestContractError } from './auth-requests.js';

const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' && value.trim().length > 0;
const optionalText = value => value == null || typeof value === 'string';
const fail = () => { throw new AuthRequestContractError('invalid provider token or known profile fields.'); };
const appleUser = raw => {
  if (raw == null) return true;
  if (typeof raw === 'string') {
    try { raw = JSON.parse(raw); } catch { return false; }
  }
  return record(raw) && ['email', 'firstName', 'lastName', 'givenName', 'familyName'].every(key => optionalText(raw[key]))
    && ['name', 'fullName', 'user'].every(key => raw[key] == null || record(raw[key])
      && ['email', 'firstName', 'lastName', 'givenName', 'familyName'].every(field => optionalText(raw[key][field])));
};

/** Direct main-backend token exchange; gateway authorization starts use their own inputs. */
export function readGoogleTokenRequest(payload) {
  if (!record(payload) || !text(payload.token)) fail();
  return payload;
}
export function readAppleTokenRequest(payload) {
  if (!record(payload) || !text(payload.identityToken)
    || !['authorizationCode', 'nonce', 'email', 'redirectURI'].every(key => optionalText(payload[key]))
    || !appleUser(payload.fullName) || !appleUser(payload.user)) fail();
  return payload;
}
